import React, {Component} from 'react'

import Tooltip from '@material-ui/core/Tooltip'
import Button from '@material-ui/core/Button'

import CreateTemplateIcon from '@material-ui/icons/Add'
import CreateFolderIcon from '@material-ui/icons/CreateNewFolder'

import EditIcon from '@material-ui/icons/Ballot'
import DeleteIcon from '@material-ui/icons/DeleteForever'
import EditTemplateItemsIcon from '@material-ui/icons/BeachAccess'
import MoveToFolderIcon from '@material-ui/icons/LowPriority'

import PaperBlock from "../../ui/PaperBlock"

/**
 * 	<ControlPanel
 * 		selected
 * 		onCreateFolderClick = {}
 * 		onCreateTemplateClick = {}
 * 		onEditTemplateItemsClick = {template}
 * 		onEditItemClick = {item}
 * 		onDeleteItemClick = {item}
 * 		onMoveToFolderClick = {item}
 * 	/>
 */

class ControlPanel extends Component {

	render() {
		return <PaperBlock style = {{display: "flex"}}>

			<Tooltip title = "Создать папку"><div>
				<Button
					onClick = {e => {
						e.stopPropagation()
						if (typeof this.props.onCreateFolderClick === "function") {
							this.props.onCreateFolderClick()
						}
					}}
				>
					<CreateFolderIcon />
				</Button>
			</div></Tooltip>

			<Tooltip title = "Создать шаблон"><div>
				<Button
					onClick = {e => {
						e.stopPropagation()
						if (typeof this.props.onCreateTemplateClick === "function") {
							this.props.onCreateTemplateClick()
						}
					}}
				>
					<CreateTemplateIcon />
				</Button>
			</div></Tooltip>

			<Tooltip title = "Предметы"><div>
				<Button
					disabled = {!(this.props.selected && (this.props.selected ? this.props.selected.type.toString() === "1" : false))}
					onClick = {e => {
						e.stopPropagation()
						if (typeof this.props.onEditItemClick === "function") {
							this.props.onEditTemplateItemsClick(this.props.selected)
						}
					}}
				>
					<EditTemplateItemsIcon />
				</Button>
			</div></Tooltip>

			<Tooltip title = "Переместить в папку"><div>
				<Button
					disabled = {!this.props.selected}
					onClick = {e => {
						e.stopPropagation()
						if (typeof this.props.onMoveToFolderClick === "function") {
							this.props.onMoveToFolderClick(this.props.selected)
						}
					}}
				>
					<MoveToFolderIcon />
				</Button>
			</div></Tooltip>

			<Tooltip title = "Редактировать"><div>
				<Button
					disabled = {!this.props.selected}
					onClick = {e => {
						e.stopPropagation()
						if (typeof this.props.onEditItemClick === "function") {
							this.props.onEditItemClick(this.props.selected)
						}
					}}
				>
					<EditIcon />
					</Button>
			</div></Tooltip>

			<Tooltip title = "Удалить"><div>
				<Button
					disabled = {!this.props.selected}
					onClick = {e => {
						e.stopPropagation()
						if (typeof this.props.onDeleteItemClick === "function") {
							this.props.onDeleteItemClick(this.props.selected)
						}
					}}
				>
					<DeleteIcon />
				</Button>
			</div></Tooltip>

		</PaperBlock>
	}

}

export default ControlPanel
